module.exports = __webpack_public_path__ + "static/rick-006-1c8d9426168c89283d7cabae2c8cac5b.jpg";